import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-access-restriction-dialog',
  templateUrl: './access-restriction-dialog.component.html',
  styleUrls: ['./access-restriction-dialog.component.css']
})
export class AccessRestrictionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AccessRestrictionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onOKClick(): void {
    this.dialogRef.close('ok');
  }
}
